import { User, ChangePasswordUser } from '@/models/user.model'

import $ from 'jquery'

export default {
  props: ['userToUpdate', 'userExpired'],

  data () {
    return {
      user: new User(),
      changePasswordUser: new ChangePasswordUser(),
      pad: [],
      errorMessage: '',
      motDePasseValide: false,
      motDePasseInvalide: false,
      version: require('../../../package.json').version
    }
  },

  created () {
    this.generatePad()
    if (!this.changePasswordUser.login && !this.userToUpdate) {
      this.$router.push('accueil')
    }

    if (this.userExpired) {
      this.errorMessage = 'Votre compte est expiré. Veuillez saisir un nouveau code confidentiel.'
    }
  },

  methods: {
    changePassword () {
      this.errorMessage = ''
      if (!this.motDePasseValide) {
        this.errorMessage = 'Les règles de conformités ne sont pas toutes respectées'
      } else if (this.changePasswordUser.password2 === '' && this.changePasswordUser.password3 === '') {
        this.errorMessage = 'Votre code d’accès et la confirmation du code d’accès doivent être renseignés'
      } else if (this.changePasswordUser.password2 === '') {
        this.errorMessage = 'Votre code d’accès doit être renseigné'
      } else if (this.changePasswordUser.password3 === '') {
        this.errorMessage = 'Votre confirmation de code d’accès doit être renseignée'
      } else {
        this.changePasswordUser.login = this.userToUpdate.login
        this.$store.dispatch('user/changePassword', this.changePasswordUser).then(
          response => {
            this.$router.push({ name: response.firstPageUrl })
            $('#modalLogin').modal('hide')
          },
          error => {
            if (error) {
              this.errorMessage = 'Au moins une des données saisies est erronée, incomplète ou manquante. Attention, composer plusieurs fois de suite une donnée erroné entraînera le blocage de votre accès au site. En cas de blocage, cliquez sur code oublié ou identifiant oublié.'
            }
            this.user.password = ''
          }
        )
      }
    },

    generatePad () {
      var numbers = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
      for (var i = 0; i < 10; i++) {
        let lengthBase = numbers.length - 1
        if (lengthBase > 0) {
          let catchedNumber = Math.floor(Math.random() * (lengthBase - 0 + 1))
          this.pad.push(numbers[catchedNumber])
          numbers.splice(catchedNumber, 1)
        } else {
          this.pad.push(numbers[0])
        }
      }
    },

    inputPassword (passwordIn, number) {
      if (passwordIn === 'password2' && this.changePasswordUser.password2.length < 8) {
        this.changePasswordUser.password2 = this.changePasswordUser.password2 + number.toString()
      } else if (passwordIn === 'password3' && this.changePasswordUser.password3.length < 8) {
        this.changePasswordUser.password3 = this.changePasswordUser.password3 + number.toString()
      }

      // On regarde si le mdp est deja dans l'historique XARM, seulement si les autres regles sont ok pour eviter les appels serveurs
      if (this.changePasswordUser.password2.length === 8 && !this.motDePasseValide && !this.motDePasseInvalide) {
        this.changePasswordUser.login = this.userToUpdate.login
        this.$store.dispatch('user/checkHistory', this.changePasswordUser).then(
          response => {
            this.motDePasseValide = true
          },
          () => {
            this.motDePasseValide = false
          }
        )
      }
    },

    trimPassword (passwordIn) {
      switch (passwordIn) {
        case 'password2':
          this.motDePasseValide = false
          this.changePasswordUser.password2 = this.changePasswordUser.password2.slice(0, -1)
          break
        case 'password3':
          this.changePasswordUser.password3 = this.changePasswordUser.password3.slice(0, -1)
          break
      }
    },

    controleSuiteInterdite (password) {
      this.motDePasseInvalide = false
      var listeSuiteInterdite = ['01234567', '12345678', '23456789', '34567890', '45678901', '56789012', '67890123', '78901234', '89012345', '90123456', '98765432', '87654321', '76543210', '65432109', '54321098', '43210987', '32109876', '21098765', '10987654', '09876543']
      if (listeSuiteInterdite.includes(password)) {
        this.motDePasseInvalide = true
        return true
      }
      return false
    },

    controleSuite3MemesChiffres (password) {
      this.motDePasseInvalide = false
      if (new RegExp('([0-9])\\1{2}').test(password)) {
        this.motDePasseInvalide = true
        return true
      }
      return false
    },

    controle3MemesChiffres (password) {
      this.motDePasseInvalide = false
      let nombreRepetition = 0
      for (var i = 0; i < password.length - 1; i++) {
        nombreRepetition = password.split(password.charAt(i)).length - 1
        if (nombreRepetition > 2) {
          this.motDePasseInvalide = true
          return true
        }
      }
      return false
    }
  }
}
